var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 11.4998V8.99984H8.99984C9.91984 8.99984 10.6665 8.25234 10.6665 7.33317C10.6665 6.41317 9.91984 5.6665 8.99984 5.6665C8.07984 5.6665 7.33317 6.41317 7.33317 7.33317H5.6665C5.6665 5.49567 7.16234 3.99984 8.99984 3.99984C10.8373 3.99984 12.3332 5.49567 12.3332 7.33317C12.3332 8.88317 11.269 10.1898 9.83317 10.5623V11.4998H8.1665Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0415 13.1665C10.0415 13.7418 9.57513 14.2082 8.99984 14.2082C8.42454 14.2082 7.95817 13.7418 7.95817 13.1665C7.95817 12.5912 8.42454 12.1248 8.99984 12.1248C9.57513 12.1248 10.0415 12.5912 10.0415 13.1665Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99984 17.3332C4.40484 17.3332 0.666504 13.5957 0.666504 8.99984C0.666504 4.40567 4.40484 0.666504 8.99984 0.666504C13.5948 0.666504 17.3332 4.40484 17.3332 8.99984C17.3332 13.5957 13.5948 17.3332 8.99984 17.3332ZM8.99984 2.33317C5.324 2.33317 2.33317 5.324 2.33317 8.99984C2.33317 12.6757 5.324 15.6665 8.99984 15.6665C12.6757 15.6665 15.6665 12.6757 15.6665 8.99984C15.6665 5.324 12.6757 2.33317 8.99984 2.33317Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "question.1da81119bad3c023a7118102f0689d33.svg";